const Arrow = () => (
  <svg viewBox='0 0 24 24'>
    <path d='M11 16.172V4h2v12.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172Z' />
  </svg>
)

export { Arrow }
